// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"AgeCheckModal_modalContent__KGE_H","modalTitle":"AgeCheckModal_modalTitle__HGqlH"};